import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import emailjs from "@emailjs/browser";
import { Turnstile } from '@marsidev/react-turnstile';
import "./BuyHome.css";

const BuyHome = () => {
  const { t } = useTranslation();
  const form = useRef();
  const [isSent, setIsSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    // 1. SÄKERHETSKONTROLL: Turnstile
    if (!token) {
      alert("Vänligen vänta tills säkerhetskontrollen är klar eller försök igen.");
      return;
    }

    // 2. SÄKERHETSKONTROLL: Honeypot
    const formData = new FormData(e.target);
    const botTrap = formData.get("website_url");

    if (botTrap) {
      console.warn("Bot detected and blocked.");
      setIsSent(true);
      return;
    }

    setLoading(true);

    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    emailjs
      .sendForm(serviceId, templateId, form.current, publicKey)
      .then(
        (result) => {
          console.log("Success:", result.text);
          setIsSent(true);
          setLoading(false);
          setToken(null);
          form.current.reset();
        },
        (error) => {
          console.error("Error details:", error);
          alert("Något gick fel, vänligen försök igen eller kontakta oss via telefon.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="mag-contact-page">
      <div className="mag-container">

        <header className="mag-list-header">
          <span className="mag-label">{t("valuation.label") || "VÄRDERING"}</span>
          <h1 className="mag-list-title">{t("valuation.title")}</h1>
          <p className="mag-list-intro">
            {t("valuation.intro")}
          </p>
        </header>

        <div className="mag-contact-grid">

          <section className="mag-contact-details-col">
            <div className="mag-editorial-quote-block">
              <h2 className="mag-editorial-quote">
                "{t("valuation.quote")}"
              </h2>

              <div className="mag-contact-text-block">
                <p className="mag-contact-desc">
                  {t("valuation.desc1")}
                </p>
                <p className="mag-contact-desc" style={{ marginTop: '20px' }}>
                  {t("valuation.desc2")}
                </p>
                <p className="mag-signature-text">
                  — {t("valuation.signature")}
                </p>
              </div>
            </div>
          </section>

          <section className="mag-contact-form-col">
            {!isSent ? (
              <>
                <div className="mag-form-intro-small">
                  <h3>{t("valuation.formTitle")}</h3>
                  <p>{t("valuation.formSub")}</p>
                </div>

                <form ref={form} onSubmit={sendEmail} className="mag-editorial-form" style={{ position: 'relative' }}>

                  {/* HONEYPOT */}
                  <div style={{
                    position: 'absolute',
                    opacity: 0,
                    zIndex: -1,
                    height: 0,
                    width: 0,
                    overflow: 'hidden',
                    pointerEvents: 'none'
                  }}>
                    <input type="text" name="website_url" tabIndex="-1" autoComplete="off" />
                  </div>

                  {/* DATA FÖR EMAILJS-MALLEN */}
                  <input type="hidden" name="form_subject" value="Värderingsförfrågan" />
                  <input type="hidden" name="time" value={new Date().toLocaleString('sv-SE')} />

                  <div className="mag-form-row">
                    <label>{t("form.name")}</label>
                    <input type="text" name="user_name" required maxLength="70" />
                  </div>
                  <div className="mag-form-row">
                    <label>{t("form.email")}</label>
                    <input type="email" name="user_email" required />
                  </div>
                  <div className="mag-form-row">
                    <label>{t("form.phone")}</label>
                    <input type="tel" name="user_phone" maxLength="25" />
                  </div>
                  <div className="mag-form-row">
                    <label>{t("form.propertyType")}</label>
                    <select name="property_type" required className="mag-form-select">
                      <option value="" disabled defaultValue>
                        {t("form.selectType") || "Välj typ av bostad"}
                      </option>
                      <option value="Villa">{t("property.villa") || "Villa"}</option>
                      <option value="Bostadsrätt">{t("property.apartment") || "Bostadsrätt"}</option>
                      <option value="Radhus">{t("property.townhouse") || "Radhus / Kedjehus"}</option>
                      <option value="Fritidshus">{t("property.cottage") || "Fritidshus"}</option>
                      <option value="Tomt">{t("property.plot") || "Tomt"}</option>
                      <option value="Annat">{t("property.other") || "Övrigt"}</option>
                    </select>
                  </div>

                  <div className="mag-form-row">
                    <label>{t("form.messageLabel") || "Information om bostaden"}</label>
                    <textarea
                      name="message"
                      rows="4"
                      maxLength="2000"
                      placeholder={t("form.messagePlaceholder") || "Berätta gärna kort om bostaden (t.ex. antal rum, renoveringar)..."}
                    />
                  </div>

                  {/* TURNSTILE WIDGET*/}
                  <Turnstile
                    siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY}
                    onSuccess={(token) => setToken(token)}
                    style={{ display: 'none' }}
                  />

                  <button type="submit" className="mag-form-btn" disabled={loading}>
                    {loading ? (t("form.sending") || "SKICKAR...") : (t("form.send") || "SKICKA FÖRFRÅGAN")}
                  </button>
                </form>
              </>
            ) : (
              <div className="mag-success-message">
                <h2 className="mag-contact-sub">{t("thankYou") || "Tack för din förfrågan!"}</h2>
                <p className="mag-contact-desc">
                  {t("valuation.successText") || "Vi har tagit emot dina uppgifter och återkommer till dig inom kort för att boka en tid för värdering."}
                </p>
                <button
                  onClick={() => setIsSent(false)}
                  className="mag-form-btn"
                  style={{ marginTop: '20px' }}
                >
                  {t("backToForm") || "Skicka ny förfrågan"}
                </button>
              </div>
            )}
          </section>

        </div>
      </div>
    </div>
  );
};

export default BuyHome;